<template>
  <div>

    <Spinner v-if="loading === true" />
    <div
      v-if="loading === false"
      class="row"
    >
      <div class="col-md-6" />
      <div class="col-md-6 create-button" />
    </div>
    <basic-table
      v-if="loading === false"
      :selectedPage = "'general_settings'"
      ref="table"
      :columns="columns"
      :values="rows"
    />
  </div>
</template>
<script>
import BasicTable from '../../../shared/tables/BasicTable.vue'
import rgisterRequestsService from '../../../services/registerRequestsService'
import Spinner from '@/shared/loader/Spinner'

export default {
  components: {
    Spinner,
    BasicTable,
  },
  data() {
    return {
      loading: false,
      editedService: '',
      columns: [
        {
          label: 'Title',
          field: 'title'
        },
        {
          label: 'Sender',
          field: 'full_name',
        },
        {
          label: 'Phone',
          field: 'phone_number',
        },
        {
          label: 'Email',
          field: 'email',
        },
      ],
      rows: [],
      searchTerm: '',
    }
  },
  created() {
    this.getRegisterRequests()
  },

  methods: {
    getRegisterRequests(withLoading = true) {
      this.loading = true
      rgisterRequestsService.index().then(response => {
        this.rows = response.data.data
        console.log(this.rows)
        this.loading = false
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
